<template>
  <div
    class="detail-right"
    v-if="courseDetail.priceModule"
  >
    <div class="detail-right__price">
      <span
        class="price__logo"
        v-if=" Number(courseDetail.priceModule.resale) !== 0 "
      >￥</span>
      <span :class="['price__resale', {'try-class': Number(courseDetail.priceModule.resale) === 0}]">{{ Number(courseDetail.priceModule.resale) === 0 ? '体验课' : courseDetail.priceModule.resale }}</span>
      <span
        class="price__origin"
        v-if="Number(courseDetail.priceModule.price) !== Number(courseDetail.priceModule.resale)"
      >{{ courseDetail.priceModule.price }}</span>
    </div>
    <!-- 促销标签 -->
    <div
      class="detail-activety"
      v-if="Object.keys(courseDetail.discountModule||{}).length"
    >
      <!-- 优惠价 -->
      <div
        v-if="Object.keys(courseDetail.discountModule||{}).length > 0"
        class="promote-price"
      >
        <span class="price-text">{{ courseDetail.discountModule.desc }}</span>
        <span class="price-tag">¥</span>
        <span class="price-number">{{ courseDetail.discountModule.price }}</span>
      </div>
      <!--      <div class="activety__detail">-->
      <!--        <div-->
      <!--          v-for="(item, index) in courseDetail.activityModule"-->
      <!--          :key="index"-->
      <!--          class="activety__items"-->
      <!--        >-->
      <!--          {{ item.name }}-->
      <!--          <div-->
      <!--            class="activety__illustrate"-->
      <!--            v-if="item.content"-->
      <!--          >{{ item.content }}</div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="detail-right__illustrate">
      <!-- 距停售仅剩2天 · 剩余5个名额 -->
      <span v-if="courseDetail.courseInfoModule.countDown">{{courseDetail.courseInfoModule.countDown}}</span>
      <span v-if="isHaveCounselorTeacher && courseDetail.classLeftNumModule.desc">
        ·
      </span>
      <span v-if="isHaveCounselorTeacher && courseDetail.classLeftNumModule.desc">{{ courseDetail.classLeftNumModule.desc }}</span>
    </div>
    <!-- 领取优惠劵 -->
    <detail-coupon
      v-if="Object.keys(courseDetail.couponModule||[]).length"
      class="detail-right__discount"
      :data="courseDetail.couponModule"
      :courseId="courseDetail.courseInfoModule.courseId"
    />
    <!-- 换购入口 -->
    <div
      class="detail-right__addPurchase"
      :class="Object.keys(incPurchase||{}).length ? 'margin-top' : ''"
      v-if="Object.keys(incPurchase||{}).length"
      @click="incPurchaseBuy($event)"
    >
      <img
        class="addPurchase__img"
        :src="incPurchase.titleIcon"
      />
      <span class="addPurchase__text">{{ incPurchase.separation }}</span>
      <span class="addPurchase__go"><img
          class="addPurchase__logo"
          src="../images/right.png"
        /></span>
    </div>
    <div
      class="activety"
      v-if="courseDetail.activityModule && Object.keys(courseDetail.activityModule||{}).length"
    >
      <!--      v-if="hasCommonActivity"-->
      <div class="activety__title"><span>活</span><span>动</span></div>
      <div class="activety__detail">
        <div
          v-for="(item, index) in courseDetail.activityModule"
          :key="index"
          class="activety__items"
        >
          {{ item.name }}
          <div
            class="activety__illustrate"
            v-if="item.content"
          >{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div
      class="detail-right__tags"
      v-if="courseDetail.serviceModule && courseDetail.serviceModule.length > 0"
    >
      <span class="tags__title"><span>服</span><span>务</span></span>
      <div
        class="detail-right__display"
        :class="{ UnExpand: !isExpand }"
        ref="tags"
      >
        <div class="tags__items">
          <a
            v-for="(item, index) in courseDetail.serviceModule"
            :key="index"
            :href="`//online.xueersi.com/article/detail/${item.id}`"
            @click="tagsHandleClick($event, item)"
            target="_blank"
          >{{ item.name }}</a>
        </div>
        <div
          class="tags__button"
          @click="handleExpand"
          v-if="showExpand"
          :class="{ 'tags__button--rotate': isExpand }"
        ></div>
      </div>
    </div>
    <!-- 选课中心兑换卡跳转过来的隐藏按钮 -->
    <detail-buy-button
      v-if="!hiddenButBtn"
      :courseDetail="courseDetail"
    ></detail-buy-button>
    <div
      class="eligible"
      v-if="
        Number(courseDetail.buttonModule.id) === 6 ||
          Number(courseDetail.buttonModule.id) === 8
      "
    >
      <div
        class="eligible__content"
        v-if="courseDetail.buttonModule.tips && !hiddenButBtn"
      >
        <!-- <i class="eligible__icon"></i> -->
        <span class="eligible__text">{{ courseDetail.buttonModule.tips }}</span>
        <a
          :href="courseDetail.buttonModule.url"
          target="_blank"
          v-if="courseDetail.buttonModule.url"
          class="eligible__choose-btn"
        >
          {{ courseDetail.buttonModule.desc }}
        </a>
      </div>
    </div>
    <!-- 入学测提示 -->
    <div
      :class="[
        Number(courseDetail.showCartButton) !== 1 ? 'tips-alone' : 'detail-right__tips'
      ]"
      v-else-if="hasSaleTips && !hiddenButBtn"
      ref="hasSaleTips"
    >
      <div :class="[
          Number(courseDetail.showCartButton) !== 1
            ? 'tips-alone__content'
            : 'detail-right__tips__content'
        ]">
        {{ courseDetail.buttonModule.tips }}
      </div>
    </div>
    <!-- 点击加价购去选课 -->
    <div v-if="openPurchaseDialog">
      <div class="dialog__background"></div>
      <div class="alert__dialog">
        <div
          class="dialog__close"
          @click="handleClosePurchase"
        ></div>
        <div class="dialog__title">{{ incPurchase.reason.title }}</div>
        <div class="dialog__content__container">
          <div class="dialog__content">{{ incPurchase.reason.content }}</div>
        </div>
        <div class="dialog__button">
          <div
            class="dialog__cancle"
            @click="handleClosePurchase"
          >取消</div>
          <div
            class="dialog__handle"
            @click="handlePurchaseDialog($event)"
          >
            {{ incPurchase.reason.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/util/user'
import DetailBuyButton from './DetailBuyButton'
import DetailCoupon from './DetailCoupon'
import { buyStatus } from '@/defines'
import { mapState } from 'vuex'

export default {
  props: {
    courseDetail: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      buyStatus,
      isExpand: false,
      showExpand: false,
      openPurchaseDialog: false,
      clickId: {
        1907: '1.3.11',
        1914: '1.3.12',
        1919: '1.3.13',
        1917: '1.3.14',
        1915: '1.3.15',
        1916: '1.3.16',
        1939: '1.3.17',
        1918: '1.3.18',
        1921: '1.3.19',
        1922: '1.3.20',
        1954: '1.3.21',
        1955: '1.3.22',
        1956: '1.3.23',
        1957: '1.3.24'
      },
      hiddenButBtn: false,
    }
  },
  components: {
    DetailBuyButton,
    DetailCoupon
  },
  computed: {
    ...mapState({
      userIsLogin: state => state.userIsLogin
    }),
    incPurchase() {
      return this.courseDetail.additionalPurchaseModule
    },
    isHaveCounselorTeacher() {
      if (this.courseDetail && this.courseDetail.teacherModule && this.courseDetail.teacherModule.counsolerInfo) {
        return !!this.courseDetail.teacherModule.counsolerInfo.length
      } else {
        return false
      }
    },
    // hasForSaleActivity() {
    //   // havePromotionAdvanceNotice 1:促销模块展示活动 0:活动模块展示
    //   return (
    //     Number(this.courseDetail.havePromotionAdvanceNotice) === 1 &&
    //     this.courseDetail.promotionLabel &&
    //     this.courseDetail.promotionLabel.length > 0
    //   )
    // },
    // hasCommonActivity() {
    //   return (
    //     Number(this.courseDetail.havePromotionAdvanceNotice) === 0 &&
    //     this.courseDetail.promotionLabel &&
    //     this.courseDetail.promotionLabel.length > 0
    //   )
    // },
    hasSaleTips() {
      return this.courseDetail && this.courseDetail.buttonModule && this.courseDetail.buttonModule.tips
    }
  },
  mounted() {
    // console.log(this.courseDetail.examPath)
    if (this.$route.query.from === 'convert' && !this.courseDetail.examModule.examPath) {
      this.hiddenButBtn = true
    }
    if (this.hasSaleTips) {
      const logData = {
        show: 'sale-tips-show',
        local_time: new Date(),
        course_price: this.courseDetail.priceModule.resale
      }
      this.$xesLogger.loadMsg(logData)
    }
    if (this.courseDetail.serviceModule && this.courseDetail.serviceModule.length > 2) {
      this.showExpand = true
      this.isExpand = false
    }
  },
  methods: {
    handleClosePurchase() {
      this.openPurchaseDialog = false
    },
    handlePurchaseDialog() {
      if (this.incPurchase.reason.url) {
        window.location.href = this.incPurchase.reason.url
      } else {
        this.openPurchaseDialog = false
      }
    },
    // 加价购点击去选课
    incPurchaseBuy(event) {
      const { courseInfoModule: { courseId }, classLeftNumModule: { classId } } = this.courseDetail
      // this.$router.push({ name: 'add-purchase', params: { courseId, classId }, query: { promotionId: this.incPurchase.promotionId, ruleId: this.incPurchase.ruleId } })
      const XESLog = {
        key: 'xeslog-courseDetail-addPurchase',
        clickid: '1.3.48',
        promotionid: this.incPurchase.promotionId,
        promotprise: this.incPurchase.discountPrice
      }
      this.$xesLogger.clickMsg({ params: XESLog })
      if (!this.userIsLogin) {
        login()
        return
      }
      if (Number(this.incPurchase.isCheck) === 0) {
        this.openPurchaseDialog = true
      } else {
        const addPurchaseUrl = this.$router.resolve({
          name: 'add-purchase',
          params: { courseId, classId },
          query: {
            promotionId: this.incPurchase.promotionId,
            ruleId: this.incPurchase.ruleId,
            courseId: courseId,
            classId: classId
          }
        })
        window.open(addPurchaseUrl.href, '_blank')
      }
    },
    handleExpand() {
      this.isExpand = !this.isExpand
    },
    tagsHandleClick(event, item) {
      const XESLog = {
        key: 'xeslog-tags-www',
        action: item.name,
        clickurl: `${window.location.protocol}//online.xueersi.com/article/detail/${item.id}`,
        courseid: this.courseDetail.courseInfoModule.courseId,
        clickid: this.clickId[item.id]
      }
      this.$xesLogger.clickMsg({ params: XESLog })
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@import 'src/views/CourseDetail/index.scss';
@import 'src/views/CourseDetail/common.scss';
@include b(detail-right) {
  padding: 40px 20px;
  background: #fff;
  @include e(illustrate) {
    color: #999999;
    font-size: 13px;
    margin-top: 10px;
    margin-bottom: 30px;
  }
  @include e(addPurchase) {
    color: #f0773c;
    margin-bottom: 28px;
    & > span,
    img {
      display: inline-block;
    }
    width: 320px;
    height: 20px;
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  @include e(tags) {
    display: flex;
    justify-content: space-between;
  }
  @include e(display) {
    display: inline-block;
    width: 255px;
    position: relative;
  }
  @include e(price) {
    & > span {
      display: inline-block;
    }
  }
  .try-class {
    font-size: 28px;
  }
  @include e(discount) {
    margin-bottom: 28px;
  }

  @include e(tips) {
    text-align: right;
    @include e(content) {
      display: inline-block;
      color: #fe9b43;
      padding: 8px 12px;
      position: relative;
      margin-top: 12px;
      max-width: 280px;
      min-width: 100px;
      border-radius: 2px;
      font-size: 14px;
      text-align: left;
      line-height: 14px;
      background: rgba(230, 188, 122, 0.16);

      &::before {
        right: 70px;
        pointer-events: none;
        position: absolute;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 8px dashed transparent;
        z-index: 1;
        border-bottom-style: solid;
        border-width: 0 8px 8px;
        border-bottom-color: #fbf4ea;
        bottom: 0;
        top: -7px;
      }
      &::after {
        right: 70px;
        pointer-events: none;
        position: absolute;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 8px dashed transparent;
        z-index: 1;
        border-bottom-style: solid;
        border-width: 0 8px 8px;
        top: -7px;
        border-bottom-color: #fbf4ea;
        bottom: -8px;
      }
    }
  }
}
.tips-alone {
  text-align: center;
  @include e(content) {
    display: inline-block;
    color: #fe9b43;
    padding: 8px 12px;
    position: relative;
    margin-top: 12px;
    max-width: 280px;
    min-width: 100px;
    border-radius: 2px;
    font-size: 14px;
    text-align: left;
    line-height: 14px;
    background: rgba(230, 188, 122, 0.16);

    &::before {
      right: 46%;
      // transform: translateX(-50%);
      pointer-events: none;
      position: absolute;
      display: block;
      content: '';
      width: 0;
      height: 0;
      border: 8px dashed transparent;
      z-index: 1;
      border-bottom-style: solid;
      border-width: 0 8px 8px;
      border-bottom-color: #fbf4ea;
      bottom: 0;
      top: -7px;
    }
    &::after {
      right: 46%;
      margin-left: 20px;
      // transform: translateX(-50%);
      pointer-events: none;
      position: absolute;
      display: block;
      content: '';
      width: 0;
      height: 0;
      border: 8px dashed transparent;
      z-index: 1;
      border-bottom-style: solid;
      border-width: 0 8px 8px;
      top: -7px;
      border-bottom-color: #fbf4ea;
      bottom: -8px;
    }
  }
}
@include b(tags) {
  @include e(button) {
    position: absolute;
    right: 0;
    top: 4px;
    height: 14px;
    width: 14px;
    background: url('../images/up.png');
    background-size: 14px 14px;
    vertical-align: middle;
    background-repeat: no-repeat;
    cursor: pointer;
    @include m(rotate) {
      transform: rotate(180deg);
    }
  }
  @include e(items) {
    display: flex;
    flex-wrap: wrap;
    width: 228px;
    & > a {
      font-size: 14px;
      color: #666666;
      line-height: 22px;
      &:after {
        content: '/';
        margin: 0 4px;
        color: grey;
      }
      &:hover {
        color: #f13232;
      }
    }
  }
}
@include b(price) {
  @include e(logo) {
    color: #f13232;
    font-size: 16px;
  }
  @include e(resale) {
    color: #f13232;
    font-size: 40px;
    line-height: 40px;
    height: 40px;
    margin-right: 8px;
  }
  @include e(origin) {
    color: #666666;
    font-size: 14px;
    text-decoration: line-through;
  }
  @include e(presale) {
    display: inline-block;
    margin-left: 20px;
    @include e(text) {
      color: #f13232;
      font-size: 14px;
      letter-spacing: 2px;
    }
    @include e(number) {
      margin-left: 2px;
      font-size: 20px;
      color: rgba(241, 50, 50, 1);
    }
  }
}
@include b(addPurchase) {
  @include e(img) {
    width: 42px;
    height: 16px;
    // padding-left: 8px;
  }
  @include e(text) {
    font-size: 14px;
    width: 240px;
    margin-left: 24px;
    overflow: hidden;
    line-height: 20px;
    height: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  @include e(logo) {
    height: 14px;
    width: 14px;
    vertical-align: middle;
  }
  @include e(go) {
    font-size: 12px;
  }
}
@include b(activety) {
  margin-bottom: 24px;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.activety__title,
.tags__title {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 22px;
  width: 42px;
  margin-right: 23px;
  color: #333333;
}
.activety {
  margin-top: -8px;
  .activety__detail {
    width: 250px;
  }
  .activety__item-cuxiao {
    color: #ffffff;
    background: #f07737;
  }
  .activety__item-common {
    color: #f07737;
    background: #ffffff;
  }
  .activety__items {
    color: #ff5e50;
    background: #f8f8f8;
    display: inline-block;
    line-height: 13px;
    // border: 1px solid #F8F8F8;
    text-align: center;
    font-size: 13px;
    margin-right: 8px;
    padding: 4px;
    border-radius: 1px;
    margin-top: 8px;
    position: relative;
    cursor: pointer;
    &:hover {
      .activety__illustrate {
        display: block;
      }
    }
    .activety__illustrate {
      display: none;
      color: #333;
      padding: 16px 16px;
      position: absolute;
      left: 0px;
      top: 30px;
      max-width: 210px;
      min-width: 100px;
      background: #fff;
      z-index: 10;
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
      font-size: 12px;
      text-align: left;
      line-height: 22px;
      &::before {
        left: 10px;
        pointer-events: none;
        position: absolute;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 11px dashed transparent;
        z-index: 1;
        border-bottom-style: solid;
        border-width: 0 11px 11px;
        border-bottom-color: #e5e5e5;
        bottom: 0;
        top: -11px;
      }
      &::after {
        left: 10px;
        pointer-events: none;
        position: absolute;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 11px dashed transparent;
        z-index: 1;
        border-bottom-style: solid;
        border-width: 0 11px 11px;
        top: -10px;
        border-bottom-color: #ffffff;
        bottom: -1px;
      }
    }
  }
}
@include b(eligible) {
  font-size: 12 px;
  @include e(content) {
    display: flex;
    justify-content: space-between;
    justify-items: center;
  }
  @include e(text) {
    width: 200px;
  }
  @include e(choose-btn) {
    color: #f13232;
    display: inline-block;
  }
}
.UnExpand {
  height: 22px;
  overflow: hidden;
}
.margin-top {
  margin-top: 20px;
}
.detail-activety {
  margin-top: 20px;
  padding: 12px 20px;
  background: rgba(250, 250, 250, 1);
  border-radius: 2px;
  .promote-price {
    display: flex;
    & > span {
      display: inline-block;
      line-height: 22px;
    }
    .price-text {
      font-size: 13px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      background: rgba(241, 50, 50, 1);
      border-radius: 2px;
      padding: 0 4px;
    }
    .price-tag {
      margin-left: 8px;
      font-size: 16px;
      color: #f13232;
    }
    .price-number {
      margin-left: 2px;
      font-size: 20px;
      color: #f13232;
    }
  }
  .activety__detail {
    // width: 250px;
  }
  .activety__item-cuxiao {
    color: #ffffff;
    background: #f07737;
  }
  .activety__item-common {
    color: #f07737;
    background: #ffffff;
  }
  .activety__items {
    color: #ff5e50;
    display: inline-block;
    line-height: 13px;
    text-align: center;
    font-size: 13px;
    margin-right: 8px;
    padding: 4px;
    margin-top: 8px;
    border-radius: 2px;
    border: 1px solid rgba(241, 50, 50, 1);
    position: relative;
    cursor: pointer;
    &:hover {
      .activety__illustrate {
        display: block;
      }
    }
    .activety__illustrate {
      display: none;
      color: #333;
      padding: 16px 16px;
      position: absolute;
      left: 0px;
      top: 30px;
      max-width: 210px;
      min-width: 100px;
      background: #fff;
      z-index: 10;
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
      font-size: 12px;
      text-align: left;
      line-height: 22px;
      &::before {
        left: 10px;
        pointer-events: none;
        position: absolute;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 11px dashed transparent;
        z-index: 1;
        border-bottom-style: solid;
        border-width: 0 11px 11px;
        border-bottom-color: #e5e5e5;
        bottom: 0;
        top: -11px;
      }
      &::after {
        left: 10px;
        pointer-events: none;
        position: absolute;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 11px dashed transparent;
        z-index: 1;
        border-bottom-style: solid;
        border-width: 0 11px 11px;
        top: -10px;
        border-bottom-color: #ffffff;
        bottom: -1px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/DetailRight.vue